import React, { useContext } from 'react'
import styles from './BackButton.module.css'
import { StepContext } from '../../../Steps/StepContainer'
import { BackButtonProps } from './types'

export const BackButton = ({ dataClickLabel }: BackButtonProps) => {
    const { handlePrev } = useContext(StepContext)
    return (
        <button
            className={styles.content}
            onClick={handlePrev}
            data-click-label={dataClickLabel}
        >
            <img
                src={'/foodslaboEf/img/common/previewIcon.svg'}
                alt={'バックボタンアイコン'}
            />
        </button>
    )
}
